import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import { getStatisticsVesselPositions } from 'actions/statistics/vesselPositions';
import { getStatisticsCargoRequests } from 'actions/statistics/cargoRequests';

import DatePicker from 'material-ui/DatePicker';

class RangeDates extends React.PureComponent {
    constructor(props) {
        super(props);

        const { from, until } = props;

        this.state = {
            fromMinDate: moment([2017, 9, 1]).toDate(),
            fromMaxDate: until,

            untilMinDate: from,
            untilMaxDate: until,

            fromDate: from,
            untilDate: until,
        };

        this.changeFromDate = this.changeFromDate.bind(this);
        this.changeUntilDate = this.changeUntilDate.bind(this);
    }

    changeFromDate(e, date) {
        this.setState({
            fromDate: date,
            untilMinDate: date,
        }, () => {
            const { fromDate, untilDate } = this.state;

            this.props.changeDateRange(fromDate, untilDate);

            this.props.getStatisticsVesselPositions(
                moment(fromDate).utcOffset(0, true).valueOf(),
                moment(untilDate).utcOffset(0, true).valueOf(),
            );

            this.props.getStatisticsCargoRequests(
                moment(fromDate).utcOffset(0, true).valueOf(),
                moment(untilDate).utcOffset(0, true).valueOf(),
            );
        });
    }

    changeUntilDate(e, date) {
        this.setState({
            untilDate: date,
            fromMaxDate: date,
        }, () => {
            const { fromDate, untilDate } = this.state;

            this.props.changeDateRange(fromDate, untilDate);
            this.props.getStatisticsVesselPositions(
                moment(fromDate).utcOffset(0, true).valueOf(),
                moment(untilDate).utcOffset(0, true).valueOf(),
            );

            this.props.getStatisticsCargoRequests(
                moment(fromDate).utcOffset(0, true).valueOf(),
                moment(untilDate).utcOffset(0, true).valueOf(),
            );
        });
    }

    render() {
        const { fromMinDate, fromMaxDate, untilMinDate, untilMaxDate, fromDate, untilDate } = this.state;

        return (
            <div className='row'>
                <div className='col-xs-6'>
                    <DatePicker
                        floatingLabelText='From'
                        autoOk
                        minDate={fromMinDate}
                        maxDate={fromMaxDate}
                        onChange={this.changeFromDate}
                        value={fromDate}
                        formatDate={(date) => {
                            return moment(date).format('MM-DD-YYYY');
                        }}
                    />
                </div>
                <div className='col-xs-6'>
                    <DatePicker
                        floatingLabelText='Until'
                        autoOk
                        minDate={untilMinDate}
                        maxDate={untilMaxDate}
                        onChange={this.changeUntilDate}
                        value={untilDate}
                        formatDate={(date) => {
                            return moment(date).format('MM-DD-YYYY');
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default connect(
    (state, {from, until,changeDateRange}) => {
        return {
            from, until, changeDateRange,
        };
    },
    dispatch => bindActionCreators({
            getStatisticsVesselPositions,
            getStatisticsCargoRequests,
    },
    dispatch),
)(RangeDates);



// WEBPACK FOOTER //
// ./app/components/Statistics/Monitor/RangeDates.jsx